import { Component, inject } from '@angular/core';
import { InstructionTableComponent } from "../instruction-table/instruction-table.component";
import { ApiService } from "../../../../services/api.service";
import { AlertService } from "../../../../shared/alert/alert.service";
import { SpinnerService } from "../../../../shared/spinner/spinner.service";
import { IInstructions } from "../../interfaces/i-instructions";
import { AlertEnum } from "../../../../shared/alert/alert.enum";
import { MatButtonModule } from "@angular/material/button";
import { AutomationAction, AutomationType } from "../../enums/automation.enum";
import { AutomationUtilityService } from "../../services/automation-utility.service";

@Component({
  selector: 'app-instruction-manager',
  imports: [
    InstructionTableComponent,
    MatButtonModule,
  ],
  providers: [
    AutomationUtilityService
  ],
  templateUrl: './instruction-manager.component.html',
  styleUrl: './instruction-manager.component.scss'
})
export class InstructionManagerComponent {
  gridData: IInstructions[] = [];
  isLoading = true;

  #apiService = inject(ApiService);
  #alertService = inject(AlertService);
  #spinnerService = inject(SpinnerService);
  #automationUtilityService = inject(AutomationUtilityService);

  constructor() {
    this.#spinnerService.show();
    this.#apiService.getAllInstructions().subscribe({
      next: (response) => {
        this.gridData = response;
        this.isLoading = false;
        this.#spinnerService.hide();
      },
      error: (error: any) => {
        this.#spinnerService.hide();
        this.#alertService.showAlert({
        message: `Failed to get Instructions.`,
        type: AlertEnum.error,
        });
        this.isLoading = false;
      }
    });
  }

  /**
   * Creates a new instruction.
   */
  onCreate(): void {
    this.#automationUtilityService.createItem(AutomationType.INSTRUCTION, AutomationAction.CREATE);
  }

}
